import React, { useCallback, useEffect, useState } from "react";
import youtubeImg from "../img/youtube.png";
import GoogleSignin from "./GoogleSignin";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { fetchAdAccounts } from "../services/settingService";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Link, Button, Select, List, Checkbox, Icon } from "@shopify/polaris";
import {
  LogoGoogleIcon,
  ArrowRightIcon,
  CreditCardIcon,
} from "@shopify/polaris-icons";
const SetupGuide = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const shop_url = params.get("shop");
  const [user, setUser] = useState(null);
  const [authUrl, setAuthUrl] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [showButtons, setShowButtons] = useState(true);
  const [showConversations, setShowConversations] = useState(false);

  const [conversations, setConversations] = useState({
    PURCHASE: "Purchase Tracking",
    ADD_TO_CART: "Add To Cart Tracking",
    BEGIN_CHECKOUT: "Begin Checkout Tracking",
    PAGE_VIEW: "Page View Tracking",
    dynamicRemarkiting: "Dynamic Remarketing",
    enhancedConversion: "Enhanced Conversions",
    includeTaxesAndShipping: "Include Taxes and Shipping",
  });
  const [selectConversations, setSelectConversations] = useState(() => {
    return Object.fromEntries(
      Object.keys(conversations || {}).map((key) => [key, true])
    );
  });
  const [error, setError] = useState(null);
  const [googleAccount, setGoogleAccount] = useState([]);
  const [triggers, setTriggers] = useState(false);
  const [pixels, setPixels] = useState(false);
  const [setup, setSetup] = useState(false);
  const [finish, setFinish] = useState(false);
  const [googleAd, setGoogleAd] = useState([]);
  const [googleTag, setGoogleTag] = useState(true);
  const [googleGTM, setGoogleGTM] = useState(true);
  const [existingPixel, setExistingPixel] = useState(false);
  const [rangeVal, setRangeVal] = useState(0);
  const [selected, setSelected] = useState("today");
  const [isPixelDone, setIsPixelDone] = useState(false);
  const [customerIds, setCustomerIds] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]); // First dropdown options
  const [selectedDropdown, setSelectedDropdown] = useState(null); // Selected value for the first dropdown
  const [subDropdownOptions, setSubDropdownOptions] = useState([]); // Second dropdown options
  const [selectedSubDropdown, setSelectedSubDropdown] = useState("");
  const [showSubDropdown, setShowSubDropdown] = useState(false);
  const [selectedManagerDropdown, setSelectedManagerDropdown] = useState([]);
  const [selectedTagManager, setSelectedTagManager] = useState("");
  const [containers, setContainers] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const [selectedWorkspace, setSelectedWorkspace] = useState("");
  const [view, setView] = useState("");
  const googleUrl = process.env.GOOGLE_APP_URL;
  const [createNewContainer, setCreateNewContainer] = useState(false);
  const accountUrl = process.env.GOOGLE_MANAGER_ACCOUNT;
  const token = process.env.REACT_APP_BEARER_TOKEN;
  const developerToken = process.env.GOOGLE_DEVELOPER_TOKEN;

  const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET; // Replace with your client secret
  const REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI; // Update this with your redirect URI
  const AUTH_SCOPES = [
    "https://www.googleapis.com/auth/adwords",
    "https://www.googleapis.com/auth/tagmanager.readonly",
    "https://www.googleapis.com/auth/tagmanager.edit.containers",
    "https://www.googleapis.com/auth/tagmanager.publish",
    "https://www.googleapis.com/auth/userinfo.profile",
    "https://www.googleapis.com/auth/userinfo.email",
  ];

  const AUTH_SCOPE = AUTH_SCOPES.join(" ");
  const triggerConstant = {
    PURCHASE: "Infinite Purchase Event",
    BEGIN_CHECKOUT: "Infinite BeginCheckout Event",
    ADD_TO_CART: "Infinite AddToCart Event",
    PAGE_VIEW: "Infinite PageViewEvent",
  };

  const [tabs, setTabs] = useState([
    {
      lable: "google",
      isOpen: true,
    },
    {
      lable: "pixel",
      isOpen: false,
    },
    {
      lable: "setup",
      isOpen: false,
    },
    {
      lable: "finish",
      isOpen: false,
    },
  ]);

  const [setupCheckbox, setSetupCheckbox] = useState([
    {
      name: "Purchase Tracking",
      checked: true,
      id: "purchase_tracking",
    },
    {
      name: "Add To Cart Tracking",
      checked: true,
      id: "add_to_cart_tracking",
    },
    // you can add more items
  ]);

  const [purchaseSetupBoxes, setPurchaseSetupBoxes] = useState([
    {
      icon: CreditCardIcon,
      card_name: "Purchase",
      check_name: "Purchase(infinitePixel)98414",
      id: "purchase",
      checked: false,
      category_name: "Purchase",
      source_name: "Website",
      action: "Secondary",
    },
    {
      icon: CreditCardIcon,
      card_name: "Add To Cart",
      check_name: "AddCart(infinitePixel)98414",
      id: "add_to_cart",
      checked: false,
      category_name: "ADD_TO_CART",
      source_name: "Website",
      action: "Secondary",
    },
    // you can add more
  ]);

  const option1 = [
    { label: "Select", value: "" },
    { label: "Solcoder", value: "solcoder" },
  ];
  const option2 = [
    { label: "Select", value: "" },
    { label: "Solcoder", value: "solcoder" },
  ];
  const option3 = [
    { label: "Select", value: "" },
    { label: "Solcoder", value: "solcoder" },
  ];
  const option4 = [
    { label: "Select", value: "" },
    { label: "Solcoder", value: "solcoder" },
  ];

  const handleStep1 = async () => {
    if (pixels === false) {
      setPixels(true);
      const tab = [...tabs];
      tab[0].isOpen = false;
      tab[1].isOpen = true;
      tab[2].isOpen = false;
      tab[3].isOpen = false;
      setTabs(tab);
      setRangeVal(50);
    } else if (setup === false) {
      setSetup(true);
      const tab = [...tabs];
      tab[0].isOpen = false;
      tab[1].isOpen = false;
      tab[2].isOpen = true;
      tab[3].isOpen = false;
      setTabs(tab);
      setRangeVal(60);
    } else {
      if (isPixelDone === false) {
        setSetup(true);
        const tab = [...tabs];
        tab[0].isOpen = false;
        tab[1].isOpen = false;
        tab[2].isOpen = false;
        tab[3].isOpen = false;
        setTabs(tab);
        setIsPixelDone(true);
        setRangeVal(80);
      } else {
        setFinish(true);
        const tab = [...tabs];
        tab[0].isOpen = false;
        tab[1].isOpen = false;
        tab[2].isOpen = false;
        tab[3].isOpen = true;
        setTabs(tab);
        setRangeVal(100);
      }
    }
  };

  const handleCreatePixel = async () => {
    setShowButtons(false);
    setShowConversations(true);
    let conversations = await fetchConversation();
  };

  const handleExistingPixel = () => {
    setShowButtons(false);
    setExistingPixel(true);
  };

  const backToGoogle = () => {
    setGoogleAccount(true);
    const tab = [...tabs];
    tab[0].isOpen = true;
    tab[1].isOpen = false;
    tab[2].isOpen = false;
    tab[3].isOpen = false;
    setTabs(tab);
    setRangeVal(0);
    setPixels(false);
  };

  const backToPixels = () => {
    setExistingPixel(false);
    const tab = [...tabs];
    tab[0].isOpen = false;
    tab[1].isOpen = true;
    tab[2].isOpen = false;
    tab[3].isOpen = false;
    setTabs(tab);
    setRangeVal(10);
    setSetup(false);
  };

  const handleSetupCheckChange = (i) => {
    const arr = [...setupCheckbox];
    arr[i].checked = !arr[i].checked;
    setSetupCheckbox(arr);
  };

  const completePixel = async () => {
    console.log("selectConversations", selectConversations);

    // const response = await axios.get(
    //   `https://tagmanager.googleapis.com/tagmanager/v2/accounts/${selectedTagManager}/containers/${selectedContainer}/workspaces/3/triggers`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${accessToken}`,
    //     },
    //   }
    // );

    // let trigr = response.data.trigger;
    // for (var conv in selectConversations) {
    //   var triggerCat = selectConversations[conv].conversionAction.category;
    //   var trig = triggerConstant[triggerCat];
    //   const triggerID = trigr.find((t) => t.name === trig);

    //   let data = JSON.stringify({
    //     name: "Google Ads Conversion Pixel",
    //     type: "html",
    //     parameter: [
    //       {
    //         key: "html",
    //         value:
    //           "<script>gtag('event', 'conversion', {'send_to': 'AW-" +
    //           selectConversations[conv].conversionAction.id +
    //           "/abc123', 'value': 0.1, 'currency': 'USD'});</script>",
    //         type: "template",
    //       },
    //     ],
    //     firingTriggerId: [triggerID.triggerId],
    //     tagFiringOption: "oncePerEvent",
    //   });

    //   console.log("datatrigger", data);

    //   let config = {
    //     method: "post",
    //     maxBodyLength: Infinity,
    //     url: `https://tagmanager.googleapis.com/tagmanager/v2/accounts/${selectedTagManager}/containers/${selectedContainer}/workspaces/3/tags`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${accessToken}`,
    //     },
    //     data: data,
    //   };

    //   axios
    //     .request(config)
    //     .then((response) => {
    //       console.log(JSON.stringify(response.data));
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // }

    try {
      const selectedGoogleAdsOption = dropdownOptions.find(
        (option) => option.value === selectedDropdown
      );

      // Set the name based on the selected option
      const googleAdsName = selectedGoogleAdsOption
        ? selectedGoogleAdsOption.label
        : "-";

      const selectedGoogleSubAdsOption = subDropdownOptions.find(
        (option) => option.value === selectedSubDropdown
      );

      // Set the name based on the selected option
      const googleSubAdsName = selectedGoogleSubAdsOption
        ? selectedGoogleSubAdsOption.label
        : "-";

      const selectedContainerOption = containers.find(
        (option) => option.value === selectedContainer
      );

      // Set the name based on the selected option
      const gtmContainerName = selectedContainerOption
        ? selectedContainerOption.label
        : "-";

      const selectedAccountOption = selectedManagerDropdown.find(
        (option) => option.value === selectedTagManager
      );

      // Set the name based on the selected option
      const gtmAccount = selectedAccountOption ? selectedAccountOption : "-";

		 let conversionLabels = {
      purchaseLabel: "-",
      addtocartLabel: "-",
      beginCheckoutLabel: "-",
      pageviewLabel: "-",
    };		
		
		
    const categories = {
      PURCHASE: "PURCHASE",
      ADD_TO_CART: "ADD_TO_CART",
      BEGIN_CHECKOUT: "BEGIN_CHECKOUT",
      PAGE_VIEW: "PAGE_VIEW",
    };

		let id = selectedSubDropdown ? selectedSubDropdown : selectedDropdown;
    const GOOGLE_ADS_API_URL = `https://googleads.googleapis.com/v17/customers/${id}/conversionActions:mutate`;

		
  for (const [key, isEnabled] of Object.entries(selectConversations)) {
      if (isEnabled && categories[key]) {
        const randomName = Math.random().toString(36).substring(2, 15); // Generate random string

		 
        const requestBody = {
          operations: [
            {
              create: {
                name: randomName,
                type: "WEBPAGE",
                category: categories[key],
                status: "ENABLED",
                valueSettings: {
                  defaultValue: 10.0,
                  defaultCurrencyCode: "USD",
                  alwaysUseDefaultValue: true,
                },
              },
            },
          ],
        };

        const response = await axios.post(GOOGLE_ADS_API_URL, requestBody, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "developer-token": "1-HYpRG2Bn3mkzOrTXp2rg",
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          console.log(`✅ Created conversion for ${key}:`, response.data);
          // Save the generated name in corresponding label
          if (key === "PURCHASE") conversionLabels.purchaseLabel = randomName;
          if (key === "ADD_TO_CART") conversionLabels.addtocartLabel = randomName;
          if (key === "BEGIN_CHECKOUT") conversionLabels.beginCheckoutLabel = randomName;
          if (key === "PAGE_VIEW") conversionLabels.pageviewLabel = randomName;
        } else {
          console.warn(`⚠️ Failed to create conversion for ${key}`);
        }
      }
    }


      const data = {
        status: "active",
        googleAdsID: selectedDropdown,
        googleAdsName: googleAdsName,
        googleSubAdsID: selectedSubDropdown,
        googleSubAdsName: googleSubAdsName,
        gtmAccount: gtmAccount,
        pixelId: "-",
        pixelName: "-",
        email: user.email,
        gtmContainerID: selectedContainer,
        gtmContainerName: gtmContainerName,
          purchaseLabel: conversionLabels.purchaseLabel,
      addtocartLabel: conversionLabels.addtocartLabel,
      beginCheckoutLabel: conversionLabels.beginCheckoutLabel,
      pageviewLabel: conversionLabels.pageviewLabel,
        conversationActions: selectConversations,
        measurementID: "-",
        uetTagID: "-",
        workspaceID: selectedWorkspace,
        shopurl: shop_url,
      };
      console.log("data", data);
      const response = await axios.post(
        "https://sgbnode.solcoder.com/google-adv",
        data
      );

      if (response.status === 201) {
        swal({
          title: "Success!",
          text: "The pixel setup has been completed successfully.",
          icon: "success",
          buttons: false,
          timer: 2000, // Automatically close after 2 seconds
        }).then(() => {
          // Redirect after showing the success message
          const redirectUrl = `/google-adds-tracking?shop=${shop_url}`;
          window.location.href = redirectUrl;
        });
      }

      console.log("API response:", response.data);
    } catch (error) {
      console.error("Error completing pixel:", error);

      swal({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
        buttons: true,
      });
    }
  };

  const handleConversationChange = (key) => {
    setSelectConversations((prev) => ({
      ...prev,
      [key]: !prev[key], // Toggle the checkbox state
    }));
  };

  const handlePurchaseChange = (i) => {
    const arr = [...purchaseSetupBoxes];
    arr[i].checked = !arr[i].checked;
    setPurchaseSetupBoxes(arr);
  };

  useEffect(() => {
    const url = `https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${encodeURIComponent(
      AUTH_SCOPE
    )}&access_type=offline&prompt=consent`;
    setAuthUrl(url);
  }, [CLIENT_ID, REDIRECT_URI, AUTH_SCOPE]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");

    if (code) {
      // Exchange Authorization Code for Access Token and Refresh Token
      const fetchTokens = async () => {
        try {
          const response = await axios.post(
            "https://oauth2.googleapis.com/token",
            {
              code: code,
              client_id: CLIENT_ID,
              client_secret: CLIENT_SECRET,
              redirect_uri: REDIRECT_URI,
              grant_type: "authorization_code",
            }
          );

          setAccessToken(response.data.access_token);
          setRefreshToken(response.data.refresh_token); // Save the refresh token

          localStorage.setItem("refreshToken", response.data.refresh_token);

          const userInfoResponse = await axios.get(
            "https://www.googleapis.com/oauth2/v3/userinfo",
            {
              headers: {
                Authorization: `Bearer ${response.data.access_token}`,
              },
            }
          );

          const userInfo = userInfoResponse.data;
          setUser(userInfo);
        } catch (err) {
          console.error("Error fetching tokens:", err);
          setError("Failed to exchange authorization code for tokens.");
        }
      };

      fetchTokens();
    }
    const refreshToken = localStorage.getItem("refreshToken");
    console.log("re", CLIENT_ID);
    if (refreshToken) {
      const fetchTokens2 = async () => {
        const response = await axios.post(
          "https://oauth2.googleapis.com/token",
          {
            client_id:
              "485585252174-rjn53kc0pmdcpu3mqvl03seur3jt8qmf.apps.googleusercontent.com",
            client_secret: "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",
            refresh_token: refreshToken,
            grant_type: "refresh_token",
          }
        );

        setAccessToken(response.data.access_token);

        const userInfoResponse = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${response.data.access_token}`,
            },
          }
        );

        const userInfo = userInfoResponse.data;
        setUser(userInfo);
        console.log("User Info:", userInfo);

        // Access specific fields
        const { given_name, family_name, email, picture } = userInfo;
        console.log("First Name:", given_name);
        console.log("Last Name:", family_name);
        console.log("Email:", email);
        console.log("Profile Picture URL:", picture);
      };
      fetchTokens2();
    }
  }, [CLIENT_ID, CLIENT_SECRET, REDIRECT_URI]);

  const fetchConversation = async () => {
    try {
      const options = [];

      let id = selectedSubDropdown ? selectedSubDropdown : selectedDropdown;
      const query = {
        query: `SELECT conversion_action.id, conversion_action.name, conversion_action.category FROM conversion_action`,
      };

      const response = await axios.post(
        `https://googleads.googleapis.com/v17/customers/${id}/googleAds:search`,
        query,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "developer-token": "1-HYpRG2Bn3mkzOrTXp2rg",
          },
        }
      );

      console.log("conversion", response.data.results);
      // setConversations(response.data.results); // Set dropdown options
    } catch (error) {
      console.error(
        "Error fetching Google Ads data:",
        error.response?.data || error
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        console.log("user", user);
        const data = await fetchAdAccounts(user.accessToken);
        setGoogleAd(data.resourceNames || []);
      }
    };

    fetchData();
  }, [user]);

  useEffect(() => {
    const fetchcustomer = async () => {
      try {
        const response = await axios.get(
          "https://googleads.googleapis.com/v17/customers/:listAccessibleCustomers",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "developer-token": "1-HYpRG2Bn3mkzOrTXp2rg",
            },
          }
        );
        const customerIds = response.data.resourceNames.map((resourceName) => {
          return resourceName.split("/")[1]; // Extract the customer ID from resourceNames like "customers/{id}"
        });
        console.log(customerIds);
        setCustomerIds(customerIds);
      } catch (error) {
        console.error(
          "Error fetching customers:",
          error.response?.data || error
        );
      }
    };

    if (accessToken) fetchcustomer();
  }, [accessToken]);

  useEffect(() => {
    const fetchTagManager = async () => {
      try {
        const response = await axios.get(
          "https://tagmanager.googleapis.com/tagmanager/v2/accounts",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        // Transform the API response into the correct format
        const transformedData = response.data.account.map((account) => ({
          label: account.name, // The display name for the account
          value: account.accountId, // The value that will be sent when selected
        }));

        setSelectedManagerDropdown(transformedData);
      } catch (error) {
        console.error(
          "Error fetching customers:",
          error.response?.data || error
        );
      }
    };
    if (accessToken) fetchTagManager();
  }, [accessToken]);

  useEffect(() => {
    const fetchGoogleAdsData = async () => {
      try {
        const options = [
          {
            value: "",
            label: "Select Main Account",
            manager: false,
          },
        ];

        for (let id of customerIds) {
          const query = {
            query: `SELECT customer_client.id, customer_client.descriptive_name, customer_client.manager, customer_client.level FROM customer_client WHERE customer_client.level = 0`,
          };

          const response = await axios.post(
            `https://googleads.googleapis.com/v17/customers/${id}/googleAds:search`,
            query,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "developer-token": "1-HYpRG2Bn3mkzOrTXp2rg",
              },
            }
          );

          // Map API response to dropdown options
          const customerData = response.data.results.map((result) => ({
            value: result.customerClient.id,
            label: result.customerClient.descriptiveName,
            manager: result.customerClient.manager,
          }));

          options.push(...customerData);
        }

        setDropdownOptions(options); // Set dropdown options
      } catch (error) {
        console.error(
          "Error fetching Google Ads data:",
          error.response?.data || error
        );
      }
    };

    if (accessToken && customerIds.length > 0) {
      fetchGoogleAdsData();
    }
  }, [customerIds, accessToken]);

  const fetchSubAccounts = async (customerId) => {
    const selectedOption = dropdownOptions.find(
      (option) => option.value === customerId
    );
    console.log("Selected Option1:", selectedOption); // Check selected customer
    if (selectedOption && selectedOption.manager === true) {
      setShowSubDropdown(true);
      try {
        const query = {
          query: `SELECT customer_client.id, customer_client.descriptive_name FROM customer_client WHERE customer_client.level = 1`,
        };

        const response = await axios.post(
          `https://googleads.googleapis.com/v17/customers/${customerId}/googleAds:search`,
          query,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "developer-token": "1-HYpRG2Bn3mkzOrTXp2rg",
            },
          }
        );

        // Check if the response contains sub-account data
        console.log("Sub-Account Response:", response.data);

        const subAccountOptions = response.data.results.map((result) => ({
          value: result.customerClient.id,
          label: result.customerClient.descriptiveName,
        }));

        setSubDropdownOptions(subAccountOptions); // Populate the second dropdown
      } catch (error) {
        console.error(
          "Error fetching sub-account data:",
          error.response?.data || error
        );
        setSubDropdownOptions([]); // Clear on error
      }
    } else {
      setShowSubDropdown(false);
      setSelectedSubDropdown([]); // Reset sub-dropdown if no manager
      setSubDropdownOptions([]); // Clear sub-dropdown options
    }
  };

  const fetchGTMAccount = async (accountId) => {
    try {
      const response = await axios.get(
        `https://tagmanager.googleapis.com/tagmanager/v2/accounts/${accountId}/containers`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // Map response data to a simplified structure for the dropdown
      const containerData = response.data.container.map((container) => ({
        label: `${container.name} - ${container.publicId}`,
        value: container.containerId, // Container ID
      }));

      setContainers(containerData);
    } catch (error) {
      console.error(
        "Error fetching containers:",
        error.response?.data || error
      );
    }
  };
  const handleChange = (option) => {
    console.log("Selected Sub-Account:", option); // This will log the selected option
    setSelectedSubDropdown(option); // Update state with the selected option
  };

  // Handle first dropdown selection
  const handleFirstDropdownChange = (selectedOptionId) => {
    console.log("Selected Option:", selectedOptionId);
    setSelectedDropdown(selectedOptionId);

    // Find the selected option and check manager
    const selectedOption = dropdownOptions.find(
      (option) => option.value === selectedOptionId
    );

    if (selectedOption && selectedOption.manager) {
      setShowSubDropdown(true);
      fetchSubAccounts(selectedOptionId); // Fetch sub-accounts if manager is true
    } else {
      setShowSubDropdown(false);
      setSubDropdownOptions([]); // Clear second dropdown
      setSelectedSubDropdown(null); // Reset selected sub-dropdown value
      console.warn(
        "Selected customer is not a manager. Clearing sub-dropdown."
      );
    }
  };

  const handleTagDropdownChange = (selectedOptionId) => {
    setSelectedTagManager(selectedOptionId);
    if (selectedOptionId) {
      fetchGTMAccount(selectedOptionId); // Fetch sub-accounts if manager is true
    } else {
      setContainers([]); // Clear second dropdown if not a manager
      console.warn(
        "Selected customer is not a manager. Clearing sub-dropdown."
      );
    }
  };

  const handleWorkspaceChange = (selectedWorkspace) => {
    setSelectedWorkspace(selectedWorkspace);
  };

  const handleContainerChange = async (selectedContainer) => {
    console.log("Selected Container:", selectedContainer);
    setSelectedContainer(selectedContainer);
    try {
      const response = await axios.get(
        `https://tagmanager.googleapis.com/tagmanager/v2/accounts/${selectedTagManager}/containers/${selectedContainer}/workspaces`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const workspaceData = response.data.workspace.map((worksp) => ({
        label: `${worksp.name}`,
        value: worksp.workspaceId, // Container ID
      }));

      setWorkspaces(workspaceData);
    } catch (error) {
      console.error(
        "Error fetching containers:",
        error.response?.data || error
      );
    }
  };

  const handleCreateNewContainer = async () => {
    if (!selectedTagManager) {
      alert("Please select a Tag Manager first.");
      return;
    }

    try {
      const response = await axios.post(
        `https://tagmanager.googleapis.com/tagmanager/v2/accounts/${selectedTagManager}/containers`,
        {
          name: "My New Container123445",
          usageContext: ["web"],
          domainName: ["solcoders.com"],
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // Fetch updated containers after creating the new container
      fetchGTMAccount(selectedTagManager);
      setView("existing");
      setCreateNewContainer(false); // Reset the "Create New" state
      alert("New container created successfully!");
    } catch (error) {
      console.error(
        "Error creating new container:",
        error.response?.data || error
      );
    }
  };

  return (
    <div className="setup-wrapper">
      <div className="setup-container">
        <div className="setup-header">
          <h4>Setup guide</h4>
          <i className="bi bi-x-lg"></i>
        </div>
        <p>
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout.
        </p>
        <Link monochrome url="#">
          <img src={youtubeImg} alt="youtube-icon" />
          Help Video
        </Link>
        <div className="range-container">
          <label htmlFor="range">
            0 of {rangeVal === 30 ? 1 : rangeVal === 60 ? 2 : 3} task Completed
          </label>
          <div className="range">
            <div className="range-fill" style={{ width: `${rangeVal}%` }}></div>
          </div>
          <span>{rangeVal}%</span>
        </div>
        <hr />

        <div className="check-wrapper">
          <input
            id="google-acc-check"
            type="checkbox"
            checked={googleAccount}
            onChange={() => setGoogleAccount(!googleAccount)}
          />
          <label htmlFor="google-acc-check">Google Account</label>
        </div>
        {tabs[0]?.isOpen === true && googleAccount && (
          <>
            <div className="google-account-container">
              <div className="good-account">
                <div>
                  <h4>Google Account</h4>
                </div>
                <div>
                  {!accessToken ? (
                    <div>
                      <a href={authUrl}>Authenticate with Google</a>
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  ) : (
                    <div>
                      {user && user.given_name && (
                        <>
                          {user.given_name} {user.family_name} <br />{" "}
                          {user.email}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {googleAd && accessToken && (
              <div className="google-account-container">
                <div className="good-ad-account-container">
                  <div>
                    <h4>Google Ad Account</h4>
                    <p>Make a right selection for your Google Ad Account</p>
                  </div>
                  <div>
                    {googleAd.map((account, index) => (
                      <span key={index}>{account}</span>
                    ))}
                    <Select
                      options={dropdownOptions} // Array of option objects
                      onChange={(selectedOption) =>
                        handleFirstDropdownChange(selectedOption)
                      } // Pass the entire option object
                      value={selectedDropdown} // Bind the selected option object to state
                      placeholder="Select a main account"
                    />

                    {subDropdownOptions && showSubDropdown == true && (
                      <Select
                        options={subDropdownOptions}
                        onChange={handleChange}
                        value={selectedSubDropdown}
                        placeholder="Select a sub-account"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {googleTag && accessToken && (
              <div className="google-account-container">
                <div className="good-ad-account-container">
                  <div>
                    <h4>Google Tag Manager</h4>
                    <p>Make a right selection for your Google Ad Account</p>
                  </div>
                  <div>
                    <Select
                      options={selectedManagerDropdown} // Use the transformed data
                      onChange={handleTagDropdownChange}
                      value={selectedTagManager} // Bind selected option to state
                      placeholder="Select a tag manager"
                    />
                  </div>
                </div>
              </div>
            )}
            {googleGTM && accessToken && (
              <div className="google-account-container">
                <div className="good-ad-account-container">
                  <div>
                    <h4>GTM Container</h4>
                    <p>
                      Create a new container or choose from an existing one.
                    </p>
                  </div>
                  <div>
                    {selectedTagManager && !view && (
                      <div style={{ display: "flex" }}>
                        <button
                          onClick={() => setView("createNew")}
                          className="link"
                        >
                          Create New Container
                        </button>
                        <button
                          onClick={() => setView("existing")}
                          className="link"
                        >
                          Select Existing Container
                        </button>
                      </div>
                    )}
                    {/* Show the "Create New" container option */}
                    {view === "createNew" && (
                      <div>
                        <button
                          onClick={handleCreateNewContainer}
                          className="link"
                        >
                          Create New Container
                        </button>
                      </div>
                    )}
                    {/* Show Existing Container Dropdown */}
                    {view === "existing" && containers.length > 0 && (
                      <div>
                        <Select
                          options={containers} // containers should be an array of objects
                          onChange={handleContainerChange}
                          value={selectedContainer} // This should be an object from containers, not just ID
                          placeholder="Select a Container"
                        />
                      </div>
                    )}

                    {workspaces && workspaces.length > 0 && (
                      <div>
                        <Select
                          options={workspaces}
                          onChange={(option) => {
                            console.log("Selected Sub-Account:", option); // Check selected sub-account
                            setSelectedWorkspace(option); // Update the selected sub-account
                          }}
                          value={selectedWorkspace}
                          placeholder="Select a Workspace"
                        />
                      </div>
                    )}
                    {selectedWorkspace && (
                      <div className="btn-container">
                        <Button icon={ArrowRightIcon} onClick={handleStep1}>
                          Continue
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        <div className="check-wrapper" style={{ margin: "20px 0px" }}>
          <input
            type="checkbox"
            id="pixels-check"
            checked={pixels}
            onChange={() => setPixels(!pixels)}
          />
          <label htmlFor="pixels-check">Pixels</label>
        </div>
        {tabs[1]?.isOpen === true && pixels && (
          <div className="pixels-setup-container">
            {showButtons && (
              <div className="center-btn">
                <Button onClick={handleCreatePixel}>Create New Pixel</Button>
                -:OR:-
                <Button onClick={handleExistingPixel}>
                  Select from Existing Pixel
                </Button>
              </div>
            )}
            {existingPixel && <p>There is no Existing coversions.</p>}

            {showConversations && (
              <div>
                <div className="setup-container-setup">
                  <h4>
                    This will create a new conversion pixel in your Google Ads
                    account and will be auto-selected for conversion tracking.
                  </h4>
                  <List type="bullet">
                    <List.Item>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page when looking
                      at its layout.
                    </List.Item>
                    <List.Item>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page when looking
                      at its layout.
                    </List.Item>
                    <List.Item>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page when looking
                      at its layout.
                    </List.Item>
                  </List>
                  <hr />
                  <div className="pixels-setup-container">
                    <div className="center-btn">
                      <h4>What necessary for Google PIxel?</h4>
                      {Object.entries(conversations || {}).map(
                        ([key, label], i) => (
                          <div key={key} className="flex items-center gap-2">
                            <Checkbox
                              checked={selectConversations?.[key] || false}
                              onChange={() => handleConversationChange(key)}
                              label={label}
                            />
                          </div>
                        )
                      )}
                    </div>

                    <div className="btn-container back">
                      <Button onClick={completePixel}>Complete</Button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="btn-container back">
              <Button onClick={backToGoogle}>Back</Button>
            </div>
          </div>
        )}
        <div className="check-wrapper" style={{ margin: "20px 0px" }}>
          <input
            type="checkbox"
            id="setup-check"
            checked={setup}
            onChange={() => setSetup(!setup)}
          />
          <label htmlFor="setup-check">Setup</label>
        </div>

        {tabs[2]?.isOpen === true && setup && (
          <div className="setup-container-setup">
            <h4>
              This will create a new conversion pixel in your Google Ads account
              and will be auto-selected for conversion tracking.
            </h4>
            <List type="bullet">
              <List.Item>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </List.Item>
              <List.Item>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </List.Item>
              <List.Item>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </List.Item>
            </List>
            <hr />
            <div className="pixels-setup-container">
              <div className="center-btn">
                <h4>What necessary for Google PIxel?</h4>
                {setupCheckbox?.map((e, i) => {
                  return (
                    <Checkbox
                      key={i}
                      label={e?.name}
                      checked={e?.checked}
                      onChange={() => handleSetupCheckChange(i)}
                    />
                  );
                })}
              </div>

              <div className="btn-container back">
                <Button onClick={backToPixels}>Back</Button>
              </div>
            </div>
          </div>
        )}

        {isPixelDone && (
          <div className="setup-container-setup">
            {purchaseSetupBoxes?.map((e, i) => {
              return (
                <div className="purchase-container" key={i}>
                  <div className="purchase-header">
                    <Icon source={e?.icon} tone="base" />
                    <h4>{e?.card_name}</h4>
                  </div>
                  <table>
                    <thead>
                      <th>Lead Conversion Actions</th>
                      <th>Category</th>
                      <th>Scource</th>
                      <th>Action Optimization</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Checkbox
                            label={e?.check_name}
                            checked={e?.checked}
                            onChange={() => handlePurchaseChange(i)}
                          />
                        </td>
                        <td>{e?.category_name}</td>
                        <td>{e?.source_name}</td>
                        <td>{e?.action}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        )}
        <div className="check-wrapper">
          <input
            type="checkbox"
            id="finish-check"
            checked={finish}
            onChange={() => setFinish(!finish)}
          />
          <label htmlFor="finish-check">Finish</label>
        </div>
      </div>
    </div>
  );
};

export default SetupGuide;
